namespace GeniuzPOS.InventoryReport {
    export interface IcReport01Form {
    }

    export class IcReport01Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport01';
    }
}
